/*global Modernizr, mowgli_config, clicked_link:true */
/*jslint browser:true */

(function() {
  'use strict';

  // Select the node that will be observed for mutations
  const targetNode = document.getElementById('page-content');

  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0 && mutation.addedNodes[0] instanceof HTMLElement) {
        if(mutation.addedNodes[0].nodeName.toLowerCase() === 'a') {
          mowgli_process_links([mutation.addedNodes[0]]);
        } else if(mutation.addedNodes[0].querySelectorAll('a').length > 0) {
          mowgli_process_links(mutation.addedNodes[0].querySelectorAll('a'));
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  mowgli_process_links(document.querySelectorAll('a'));
}());

function mowgli_process_links(links) {
  'use strict';

  links.forEach((link) => {
    if(link.nodeName.toLowerCase() === 'a' && !link.classList.contains('js-link-processed') && !link.closest('#wpadminbar')) {
      link.classList.add('disable-transition');
      link.classList.add('js-link-processed');

      var link_type = 'right',
          new_window = false,
          button_icon;

      if(link.hasAttribute('target') && link.getAttribute('target') === '_blank') {
        new_window = true;
        link_type = 'external';
      }

      if(!link.classList.contains('no-icon')) {
        if(link.classList.contains('editor-button')) {
          if(!link.classList.contains('button')) {
            link.innerHTML =  mowgli_config['button-link-before'] + link.innerHTML + mowgli_config['button-link-after'];
            link.classList.add('mowgli-button');
          }
        } else if(link.classList.contains('action-download')) {
          button_icon = link.querySelector('svg');

          if(button_icon) {
            button_icon.querySelector('use').setAttribute('xlink:href', '#link-download');
            button_icon.classList.remove('hidden');
          } else {
            link.insertAdjacentHTML(mowgli_config['action-download-position'], '<svg class="icon" viewBox="0 0 24 24"><use xlink:href="#link-download"></use></svg>');
          }
        } else if((link.classList.contains('button') || link.classList.contains('link-block') || link.classList.contains('resources-link')) && link_type !== 'right' && !link.classList.contains('icon-only')) {
          button_icon = link.querySelector('svg');

          if(button_icon) {
            button_icon.querySelector('use').setAttribute('xlink:href', '#link-' + link_type);
            button_icon.classList.remove('hidden');
          } else {
            link.insertAdjacentHTML('beforeend', '<svg class="icon" viewBox="0 0 24 24"><use xlink:href="#link-' + link_type + '"></use></svg>');
          }
        } else if(!link.classList.contains('button') && link_type !== 'right' && !link.hasAttribute('data-external')) {
          button_icon = link.querySelector('svg');

          if(button_icon) {
            button_icon.querySelector('use').setAttribute('xlink:href', '#link-' + link_type);
            button_icon.classList.remove('hidden');
          } else {
            if(link.classList.contains('caption-link')) {
              link.insertAdjacentHTML('beforeend', '<svg class="icon" viewBox="0 0 24 24"><use xlink:href="#link-caption_' + link_type + '"></use></svg>');
            } else {
              link.insertAdjacentHTML('beforeend', '<svg class="icon" viewBox="0 0 24 24"><use xlink:href="#link-' + link_type + '"></use></svg>');
            }
          }
        }
      }

      if(new_window) {
        link.insertAdjacentHTML('beforeend', '<i class="screen-reader-text">link opens in a new window</i>');
      }

      // Trigger a reflow, flushing the CSS changes before we turn transitions back on
      link.offsetHeight;
      link.classList.remove('disable-transition');
    }
  });
}
